import {createStateMaker} from '@shared/helpers/object'

import {RefundCode} from '@web/core/constants'

import {PurchaserState} from './interfaces'

export function createNaverMembershipState(): PurchaserState['naverMembership'] {
    return {
        currentEpisode: null,
        shouldShowQuickJoinMembershipBanner: false,
        subscribed: false,
        membershipBenefitLayerExposed: false,
        membershipPlcc: {
            plccCardStatementExposed: false,
            plccCardTextBannerExposed: false,
            plccExpectedPercentage: 0,
            plccMaximumAmount: 0,
            plccPointBenefitTextBannerExposed: false,
        },
    }
}

export const getInitialState = (): PurchaserState => ({
    alarmType: null,
    adult: true,
    child: true,
    adultAuthentication: {
        isRequired: false,
        token: '',
        certificationMethod: null,
    },
    shouldUpdateAlarmType: false,
    emailAddress: '',
    naverId: '',
    naverIdNo: '',
    name: '',
    phoneNumber: '',
    duplicatePhoneNumberUsingMember: false,
    refundMethodType: RefundCode.BANK_ACCOUNT,
    refundAccounts: [],
    profileImageUrl: '',
    nickName: '',
    naverMembership: createNaverMembershipState(),
    isPaymentMethodRegistered: null,
    isAMLTarget: null,
    userAuthStatus: 'CERTIFICATE',
})

export const makeMock = createStateMaker<PurchaserState>(getInitialState)
